import { createV3Queries } from "@query/utils/createV3Queries";
import { taxWithholdingsApi } from "@api";
import { queriesInternalAccounts } from "./queriesInternalAccounts";

export const queriesTaxWithholdings = createV3Queries(
  "taxWithholdingsApi",
  taxWithholdingsApi,
  {
    // Scheduling/cancelling an IRS payment adds or removes a row in the
    // tax-withholding transaction feed and moves funds within the
    // tax-withholding account. The name-derived default can't infer these
    // (entity "TaxPayment" matches neither the transaction list nor the
    // balance), so declare them: refresh the feed and the account balance.
    scheduleTaxPayment: queries => ({
      dependencies: () => [
        queries.listTaxWithholdingTransactions.queryKeyBase,
        queriesInternalAccounts.getInternalAccountBalance.queryKeyBase
      ]
    }),
    cancelTaxPayment: queries => ({
      dependencies: () => [
        queries.listTaxWithholdingTransactions.queryKeyBase,
        queriesInternalAccounts.getInternalAccountBalance.queryKeyBase
      ]
    })
  }
);
